import { useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import type { UnSignedSignatureBox, SignatureBox } from 'services/entities/SignatureTypes';
import { useAppDispatch } from '../grid/reduxStore/Store';
import { useSocketClient } from '../../../providers/SocketContext';
import { useCurrentUser } from '../../../providers/UserProvider';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion';
import { SignatureInsertCommand } from '../UndoRedo/SignatureInsertCommand';

export function useSignatureInsertHandler() {
  const dispatch = useAppDispatch();
  const { socketClient } = useSocketClient();
  const { data } = useCurrentUser();
  const userId = data.id;
  const checkDocumentLockStatus = useCheckDocumentLockStatus();

  return useCallback(
    async (sectionId: string, signature: UnSignedSignatureBox): Promise<string | null> => {
      const signatureWithId = {
        ...signature,
        signatureBoxId: uuidv4(),
      } as SignatureBox;

      const command = new SignatureInsertCommand(
        { dispatch, socketClient, userId, checkDocumentLockStatus },
        { sectionId, signature: signatureWithId }
      );

      const success = await command.persistToSocket();
      if (!success) {
        console.error('useSignatureInsertHandler: socket persist failed');
        return null;
      }

      UndoRedoManagerCommandVersion.getUndoRedoManager().pushUndoRedoCommands(command);
      return command.getCurrentBlockId();
    },
    [dispatch, socketClient, userId, checkDocumentLockStatus]
  );
}
